import './menu-separator.scss';

export default function MenuSeparator(): JSX.Element {
  return <li aria-hidden aria-orientation="horizontal" className="rbui-menu-separator" role="separator" />;
}

MenuSeparator.displayName = 'MenuSeparator';
